const readMethodMap = new Map([
  ['ONLINE', 'Online'],
  ['MANUAL', 'Manual'],
  ['TERMINAL_CONTACT_EMV', 'Terminal - Contact EMV'],
  ['TERMINAL_CONTACTLESS_EMV', 'Terminal - Contactless EMV'],
  ['TERMINAL_UNKNOWN', 'Terminal - unknown'],
  ['CARD_ON_FILE', 'Card on file'],
]);

export function formatReadMethod(readMethod) {
  return readMethodMap.get(readMethod) ?? 'not set';
}
